import { useEffect, useState } from "react";
import fondoNoticiasDefault from "../assets/img/noticias.webp";
import { useParams } from "react-router-dom";
import dataJson from "../assets/json/datos.json";

export default function Noticias() {
  const { sede } = useParams();
  const [fondoImg, setFondoImg] = useState(fondoNoticiasDefault);
  const [iframeUrl, setIframeUrl] = useState(
    "https://widget.tagembed.com/317304?website=1",
  );

  useEffect(() => {
    if (!sede) return;
    const dataSede = dataJson[sede];

    if (dataSede?.imagenes?.fondoNoticias) {
      try {
        const fondo = require(
          `../assets/img/${dataSede.imagenes.fondoNoticias}`,
        );
        setFondoImg(fondo);
      } catch {
        setFondoImg(fondoNoticiasDefault);
      }
    } else {
      setFondoImg(fondoNoticiasDefault);
    }

    if (dataSede?.imagenes?.iframeNoticias) {
      setIframeUrl(dataSede.imagenes.iframeNoticias);
    }
  }, [sede]);

  return (
    <section
      id="noticias"
      className="py-5 bg-light"
      style={{
        background: `linear-gradient(to right, rgba(255,255,255,0.85), rgba(255,255,255,0.85)), url(${fondoImg}) center/cover no-repeat`,
      }}
    >
      <div className="container text-center">
        <h2
          className="mb-4 fw-bold"
          style={{ fontSize: "3em", color: "#001A66" }}
        >
          Últimas Noticias
        </h2>
        <p
          className="mb-4 fw-semibold"
          style={{ fontSize: "1.5em", color: "#001A66" }}
        >
          Entérate de los eventos, ferias, actividades y congresos de la UNO
        </p>

        {/* CONTENEDOR MÁSCARA (Define el tamaño visible final) */}
        <div
          className="mx-auto"
          style={{
            maxWidth: "900px",
            height: "530px",
            overflow: "hidden",
            position: "relative",
            borderRadius: "12px",
          }}
        >
          <iframe
            src={iframeUrl}
            allow="fullscreen"
            title="Noticias UNO"
            style={{
              width: "100%",
              height: "650px",
              marginTop: "-48px",
              border: "none",
              display: "block",
            }}
          ></iframe>
        </div>
      </div>
    </section>
  );
}
